/*
 Best practice for Font Awesome usage is to only import the icons you are actually using.

 I centralized icon importing to a separate file in order to not clutter up /main.js

 Icons: https://fontawesome.com/
 Vue Package Docs: https://github.com/FortAwesome/vue-fontawesome
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

//Specify which PRO LIGHT icons to import.
//NOTE: Try to keep this list alphabetical.
import {
    faBars,
    faBan,
    faCircleExclamation,
    faCircleMinus,
    faCirclePlus,
    faCoins,
    faCreditCard,
    faEarthAmericas,
    faHexagonExclamation,
    faHourglass,
    faIdCard,
    faLink,
    faLinkSlash,
    faLocationDot,
    faLocationCheck,
    faMapPin,
    faPlane,
    faPlaneArrival,
    faPlaneDeparture,
    faShieldCheck,
    faSquareCheck,
    faSquareEnvelope,
    faSquarePhone,
    faTicketAirline,
    faTicketsAirline,
    faUpRightFromSquare,
    faUser
} from '@fortawesome/pro-light-svg-icons';

//Specify which FREE SOLID icons to import.
//NOTE: Try to keep this list alphabetical.
import {
    faQuoteLeft,
    faQuoteRight
} from '@fortawesome/free-solid-svg-icons';

//Specify which PRO DUOTONE icons to import.
//NOTE: Try to keep this list alphabetical.
import {
    faCircleNotch,
    faPlaneEngines
} from '@fortawesome/pro-duotone-svg-icons';

//Specify which FREE BRANDS icons to import.
//NOTE: Try to keep this list alphabetical.
import {
    faCcAmex,
    faCcDiscover,
    faCcMastercard,
    faCcVisa
} from '@fortawesome/free-brands-svg-icons';

//Add icons to the font awesome library.
//NOTE: Try to keep this list alphabetical.
library.add(

    //PRO LIGHT (fal)
    faBars,
    faBan,
    faCircleExclamation,
    faCircleMinus,
    faCirclePlus,
    faCoins,
    faCreditCard,
    faEarthAmericas,
    faHexagonExclamation,
    faHourglass,
    faIdCard,
    faLink,
    faLinkSlash,
    faLocationDot,
    faLocationCheck,
    faMapPin,
    faPlane,
    faPlaneArrival,
    faPlaneDeparture,
    faShieldCheck,
    faSquareCheck,
    faSquareEnvelope,
    faSquarePhone,
    faTicketAirline,
    faTicketsAirline,
    faUpRightFromSquare, //replacement for fa-external that is more generic
    faUser,

    //PRO DUOTONE (fad)
    faCircleNotch,
    faPlaneEngines,

    //FREE SOLID (fas)
    faQuoteLeft,
    faQuoteRight,

    //FREE BRANDS (fab)
    faCcAmex,
    faCcDiscover,
    faCcMastercard,
    faCcVisa
);


export default FontAwesomeIcon;